export enum AuditSource {
	Portal= "PORTAL",
	Splitter= "SPLITTER",
	Mailer= "MAILER"
}
